/**
 * The places the owner keeps plants.
 *
 * Only reading: creating a Location is deliberately not offered. He has a
 * balcony and a reception room, and the schema already takes more whenever that
 * stops being true.
 */
export interface Location {
  id: string;
  name_ar: string;
  name_en: string;
  placement: "indoor" | "outdoor";
}

export async function fetchLocations(signal?: AbortSignal): Promise<Location[]> {
  const response = await fetch("/v1/locations", { signal });
  if (!response.ok) throw new Error(`The API answered ${response.status}.`);
  const body = await response.json();
  return body.locations ?? [];
}
